import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import AppModalShell from "../common/AppModalShell.jsx";
import MediaVideoCover, { MediaImageCover } from "../common/MediaVideoCover.jsx";

export default function EventPromoGallerySection({ items = [], isHost = false, onEdit }) {
  const { t } = useTranslation("events");
  const [preview, setPreview] = useState(null);
  if (!items.length) return null;

  return (
    <>
      <section className="my-[22px]">
        <div className="flex items-center justify-between gap-3">
          <h2 className="text-[24px] font-semibold leading-[28px] text-white">
            {t("events.details.promo_gallery", { defaultValue: "Event gallery" })}
          </h2>
          {isHost && onEdit ? (
            <button type="button" onClick={onEdit} className="rounded-full border border-white/15 bg-white/10 px-3.5 py-2 text-[12px] font-semibold text-white">
              {t("events.details.promo_gallery_edit", { defaultValue: "Edit" })}
            </button>
          ) : null}
        </div>
        <div className="-mx-[30px] -mb-8 mt-3 overflow-x-auto overflow-y-hidden pb-10 scrollbar-hide overscroll-x-contain">
          <div className="flex w-max gap-[10px] px-[30px]">
            {items.map((item) => (
              <button key={item.id} type="button" onClick={() => setPreview(item)} className="relative h-[190px] w-[145px] shrink-0 overflow-hidden rounded-[20px] border border-white/15 bg-white/[0.06] p-0 shadow-[0_16px_32px_rgba(0,0,0,0.24)]">
                {item.type === "video" ? (
                  <MediaVideoCover
                    src={item.url}
                    posterSrc={item.thumbnail_url || item.thumbnailUrl || ""}
                    remoteFirstFrame
                    eager
                    showStatus
                  />
                ) : (
                  <MediaImageCover
                    src={item.thumbnail_url || item.thumbnailUrl || item.url}
                    fallbackSrc={item.url}
                    eager
                    showStatus
                  />
                )}
                {item.type === "video" ? <span className="absolute right-2 top-2 flex h-7 w-7 items-center justify-center rounded-full bg-black/55 text-white">▶</span> : null}
              </button>
            ))}
          </div>
        </div>
      </section>

      <AppModalShell open={Boolean(preview)} onClose={() => setPreview(null)} title={t("events.details.promo_gallery", { defaultValue: "Event gallery" })} size="lg">
        {preview ? (
          <div className="overflow-hidden rounded-[20px] bg-black/30">
            {preview.type === "video" ? (
              <video src={preview.url} controls playsInline preload="none" className="max-h-[70dvh] w-full object-contain" />
            ) : (
              <img src={preview.url} alt="" className="max-h-[70dvh] w-full object-contain" />
            )}
          </div>
        ) : null}
      </AppModalShell>
    </>
  );
}
